import { GET_THEME, SET_THEME } from '../types/General/themeActionTypes'

const initialState = {
    theme: 'light'
}

const themeReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_THEME:
            return {
                ...state,
                theme: action.payload
            }
        case GET_THEME:
            return {
                theme: state.theme
            }
        default:
            return { ...state }
    }
}

export default themeReducer;